export enum Role {
    functionalHeadMines = "Functional Head- Mines",
    sectionHeadMinesOperations = "Section Head: Mines Operations",
    shiftOperations = "Shift operations",
    supervisor = "Supervisor",
    seniorSupervisorShiftOperations = "Senior Supervisor: Shift Operations",
    officerShiftOperations = "Officer: Shift operations",
    seniorEngineerShiftOperations = "Senior Engineer: Shift operations",
    supervisorShiftOperations = "Supervisor: Shift Operations",
    shiftInChargeOperations = "Shift In Charge-Operations",
    engineerShiftOperations = "Engineer: Shift operations",
    sectionHeadMinesOperationsAndPlanning = "Section Head: Mines Operations & Planning",
    mis = "MIS",
    geologist = "Geologist",
    surveyor = "Surveyor",
    sectionHeadDrillingAndBlasting = "Section Head: Drilling & Blasting",
    drillingAndBlasting = "Drilling and Blasting",
    blaster = "Blaster",
    drillingAndBlastingTrainee = "Drilling and Blasting: Trainee",
    departmentHead = "Department Head",
    shMinesMaintenance = "SH Mines Maintenance",
    engineer = "Engineer",
    seniorEngineer = "Senior Engineer",
    assistantManager = "Assistant Manager",
    assistantOfficer = "Assistant Officer",
    seniorSupervisor = "Senior Supervisor",
    juniorEngineer = "Junior Engineer",

    coo = "COO",
    cmo = "CMO",
    unitHead = "Unit Head",
    mineCellHo = "Mine Cell - HO",
    fh = "FH",
    dhMinesOperation = "DH Mine Operation",
    planningEngineer = "Planning Engineer",
    drillBlastEngineer = "Drill/Blast Engineer",
    mineOperationEngineer = "Mine Operation Engineer",
    qcAnalysisLab = "QC Analysis",
    dhMineMaintenance = "DH Mine Maintenance",
    maintenanceEngineer = "Maintenance Engineer",

    test = "Test",
    masterAdmin = "Master Admin",
    customerAdmin = "Customer Admin",
    unitAdmin = "Unit Admin",
    operator = "Operator",
    fieldEngineer = 'Field Engineer',
    shiftIncharge = 'Shift In-Charge (Mines)'
}
export enum Module {
    configuration = 'Unit Configuration',
    mineInsights = 'Mine Insights',
    planning = 'Planning',
    operationsControl = 'Operations Control',
    maintenance = 'Maintenance',
    drillAndBlast = 'Drill & Blast',
    gradeControl = 'Grade Control',
    mineOptimization = 'Mine Optimization',
    overview = 'Overview',
    kpicomparison = 'kpi comparison',
    sap = 'Sap',
    esg = 'esg',
    viewnotification = 'view notification',
    customerAdmin = 'customer admin',
    productConfig = 'Product Configuration',
    diagnostics = 'Diagnostics'
}